import { Component, input } from '@angular/core';
import { ParseRequestData } from '../../stores/parse-requests.store';
import { Badge } from 'excellence-ui';
import { DatePipe } from '@angular/common';
import { NgIcon } from '@ng-icons/core';
import { OrganizationFileUrlPipe } from '../../../organizations/pipes/organization-file-url-pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-parse-requests-details-edit-form',
  imports: [Badge, DatePipe, NgIcon, OrganizationFileUrlPipe, TranslocoPipe],
  templateUrl: './parse-requests-details-edit-form.html',
})
export class ParseRequestsDetailsEditForm {
  parseRequest = input.required<ParseRequestData>();
  organizationId = input.required<string>();
  parseRequestId = input.required<string>();
}
